var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboAddCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.000244141C4.48571 0.000244141 0 4.48596 0 10.0002C0 15.5145 4.48571 20.0002 10 20.0002C15.5143 20.0002 20 15.5145 20 10.0002C20 4.48596 15.5143 0.000244141 10 0.000244141ZM10 18.2574C5.44762 18.2574 1.74286 14.5526 1.74286 10.0002C1.74286 5.44786 5.44762 1.7431 10 1.7431C14.5524 1.7431 18.2571 5.44786 18.2571 10.0002C18.2571 14.5526 14.5524 18.2574 10 18.2574Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9143 9.1336H10.8666V6.08598C10.8666 5.84789 10.6762 5.64789 10.4285 5.64789H9.56187C9.32378 5.64789 9.12378 5.83836 9.12378 6.08598V9.1336H6.07616C5.83806 9.1336 5.63806 9.32408 5.63806 9.5717V10.4384C5.63806 10.6765 5.82854 10.8765 6.07616 10.8765H9.12378V13.9241C9.12378 14.1622 9.31425 14.3622 9.56187 14.3622H10.4285C10.6666 14.3622 10.8666 14.1717 10.8666 13.9241V10.8765H13.9143C14.1523 10.8765 14.3523 10.686 14.3523 10.4384V9.5717C14.3523 9.3336 14.1619 9.1336 13.9143 9.1336Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboAddCircle);
export default __webpack_public_path__ + "static/media/FBOAddCircle.296deb0ca3a3b63b4518876338e81e5b.svg";
export { ForwardRef as ReactComponent };